import { Component, Input, OnInit } from '@angular/core';
import { GenerateAnnexPreviewRequest } from 'src/app/contracts/requests/annexes/generate-annex-preview-request';
import { AnnexDetailsAnnexEntry, AnnexDetailsWorkerAgreementEntry } from 'src/app/models/dtos/annexes/annex-details-dto';
import { EmploymentAgreementDetailsDto } from 'src/app/models/dtos/employment-agreement-details-dto';
import { WorkerAgreementForAnnexDto } from 'src/app/models/dtos/worker-agreements/worker-agreement-for-annex-dto';

@Component({
  selector: 'app-annex-summary',
  templateUrl: './annex-summary.component.html',
  styleUrls: ['./annex-summary.component.scss'],
  standalone: false,
})
export class AnnexSummaryComponent implements OnInit {
  @Input() mode: 'summary' | 'details' = 'summary';
  @Input() agreement: EmploymentAgreementDetailsDto | AnnexDetailsWorkerAgreementEntry;
  @Input() annexData: GenerateAnnexPreviewRequest | AnnexDetailsAnnexEntry;
  @Input() dataForAnnex: WorkerAgreementForAnnexDto | AnnexDetailsWorkerAgreementEntry;

  ngOnInit(): void {}

  get currentColumnLabel(): string {
    return this.mode === 'details' ? 'Annex.PreviousValue' : 'Annex.Current';
  }

  get hasJobTitleChange(): boolean {
    return this.hasJobTitleSectionChange && !!this.annexData?.JobTitleName;
  }

  get hasOrganizationalUnitChange(): boolean {
    return this.hasJobTitleSectionChange && !!this.annexData?.OrganizationalUnitName;
  }

  get hasJobTitleSectionChange(): boolean {
    return this.annexData?.ChangesJobTitle || false;
  }

  get hasTemporaryWorkplaceSectionChange(): boolean {
    return this.annexData?.ChangesTemporaryWorkplace || false;
  }

  get hasWorkingTimeSectionChange(): boolean {
    return this.annexData?.ChangesWorkingTimeGroup || false;
  }

  get hasWagesSectionChange(): boolean {
    return this.annexData?.ChangesWage || false;
  }

  get currentWages(): any[] {
    return this.dataForAnnex?.Wages || [];
  }

  get newWages(): any[] {
    return this.annexData?.Wages || [];
  }

  get hasSupervisorSectionChange(): boolean {
    return this.annexData?.ChangesSupervisor || false;
  }

  get hasAnyChanges(): boolean {
    return this.hasJobTitleSectionChange || this.hasWagesSectionChange || this.hasTemporaryWorkplaceSectionChange || this.hasSupervisorSectionChange || this.hasWorkingTimeSectionChange;
  }

  get newSupervisorName(): string | null {
    return (this.annexData as any)?.SupervisorName ?? (this.annexData as any)?.PotentialSupervisorName ?? null;
  }
}
